// Templates de funil pré-definidos para o Chatwoot
export const FUNNEL_TEMPLATES = [
  {
    id: 'vendas',
    name: 'Vendas',
    funnel_type: 'sales',
    description: 'Funil clássico de vendas',
    stages: {
      prospeccao: {
        label: 'Prospecção',
        color: '#3B82F6',
        position: 0,
        description: 'Identificação de leads',
        allow_new_conversations: true,
      },
      qualificacao: {
        label: 'Qualificação',
        color: '#10B981',
        position: 1,
        description: 'Análise de potencial',
      },
      proposta: {
        label: 'Proposta',
        color: '#F59E0B',
        position: 2,
        description: 'Envio de propostas',
      },
      negociacao: {
        label: 'Negociação',
        color: '#8B5CF6',
        position: 3,
        description: 'Ajustes e negociação',
      },
      fechamento: {
        label: 'Fechamento',
        color: '#EF4444',
        position: 4,
        description: 'Conclusão da venda',
      },
    },
    settings: {
      icon: '💰',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'prospeccao',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'suporte',
    name: 'Suporte',
    funnel_type: 'support',
    description: 'Atendimento ao cliente',
    stages: {
      novo: {
        label: 'Novo',
        color: '#EF4444',
        position: 0,
        description: 'Tickets recém criados',
        allow_new_conversations: true,
      },
      em_analise: {
        label: 'Em Análise',
        color: '#F59E0B',
        position: 1,
        description: 'Em investigação',
      },
      aguardando_cliente: {
        label: 'Aguardando Cliente',
        color: '#3B82F6',
        position: 2,
        description: 'Esperando resposta',
      },
      em_resolucao: {
        label: 'Em Resolução',
        color: '#8B5CF6',
        position: 3,
        description: 'Sendo solucionado',
      },
      resolvido: {
        label: 'Resolvido',
        color: '#10B981',
        position: 4,
        description: 'Problema resolvido',
      },
    },
    settings: {
      icon: '🛠️',
      agent_ids: [],
      team_ids: [],
      auto_assign: true,
      default_stage: 'novo',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: true,
      enable_automation: false,
      conversation_limit: 10,
    },
  },
  {
    id: 'projeto',
    name: 'Projetos',
    funnel_type: 'projects',
    description: 'Gestão de projetos',
    stages: {
      backlog: {
        label: 'Backlog',
        color: '#6B7280',
        position: 0,
        description: 'Ideias e requisitos',
        allow_new_conversations: true,
      },
      planejamento: {
        label: 'Planejamento',
        color: '#3B82F6',
        position: 1,
        description: 'Em planejamento',
      },
      desenvolvimento: {
        label: 'Em Desenvolvimento',
        color: '#F59E0B',
        position: 2,
        description: 'Em execução',
      },
      revisao: {
        label: 'Revisão',
        color: '#8B5CF6',
        position: 3,
        description: 'Em revisão',
      },
      concluido: {
        label: 'Concluído',
        color: '#10B981',
        position: 4,
        description: 'Finalizado',
      },
    },
    settings: {
      icon: '📋',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'backlog',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: true,
      conversation_limit: 0,
    },
  },
  {
    id: 'marketing',
    name: 'Marketing',
    funnel_type: 'marketing',
    description: 'Campanhas e leads',
    stages: {
      lead: {
        label: 'Lead',
        color: '#3B82F6',
        position: 0,
        description: 'Novo contato',
        allow_new_conversations: true,
      },
      mql: {
        label: 'MQL',
        color: '#10B981',
        position: 1,
        description: 'Marketing Qualified Lead',
      },
      sql: {
        label: 'SQL',
        color: '#F59E0B',
        position: 2,
        description: 'Sales Qualified Lead',
      },
      oportunidade: {
        label: 'Oportunidade',
        color: '#8B5CF6',
        position: 3,
        description: 'Em negociação',
      },
      cliente: {
        label: 'Cliente',
        color: '#EF4444',
        position: 4,
        description: 'Venda concluída',
      },
    },
    settings: {
      icon: '📢',
      agent_ids: [],
      team_ids: [],
      auto_assign: true,
      default_stage: 'lead',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: true,
      conversation_limit: 0,
    },
  },
  {
    id: 'recrutamento',
    name: 'Recrutamento',
    funnel_type: 'recruitment',
    description: 'Processo seletivo',
    stages: {
      candidatura: {
        label: 'Candidatura',
        color: '#3B82F6',
        position: 0,
        description: 'CVs recebidos',
        allow_new_conversations: true,
      },
      triagem: {
        label: 'Triagem',
        color: '#6B7280',
        position: 1,
        description: 'Análise inicial',
      },
      entrevista: {
        label: 'Entrevista',
        color: '#F59E0B',
        position: 2,
        description: 'Processo de entrevistas',
      },
      avaliacao: {
        label: 'Avaliação',
        color: '#8B5CF6',
        position: 3,
        description: 'Decisão final',
      },
      contratado: {
        label: 'Contratado',
        color: '#10B981',
        position: 4,
        description: 'Aprovado',
      },
    },
    settings: {
      icon: '👥',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'candidatura',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'onboarding',
    name: 'Onboarding',
    funnel_type: 'onboarding',
    description: 'Integração de clientes',
    stages: {
      cadastro: {
        label: 'Cadastro',
        color: '#3B82F6',
        position: 0,
        description: 'Novo cliente cadastrado',
        allow_new_conversations: true,
      },
      documentacao: {
        label: 'Documentação',
        color: '#F59E0B',
        position: 1,
        description: 'Coleta de documentos',
      },
      configuracao: {
        label: 'Configuração',
        color: '#8B5CF6',
        position: 2,
        description: 'Setup inicial',
      },
      treinamento: {
        label: 'Treinamento',
        color: '#10B981',
        position: 3,
        description: 'Capacitação do cliente',
      },
      ativo: {
        label: 'Ativo',
        color: '#EF4444',
        position: 4,
        description: 'Cliente operacional',
      },
    },
    settings: {
      icon: '🚀',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'cadastro',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'conteudo',
    name: 'Produção de Conteúdo',
    funnel_type: 'content',
    description: 'Criação e publicação',
    stages: {
      pauta: {
        label: 'Pauta',
        color: '#6B7280',
        position: 0,
        description: 'Ideias e temas',
        allow_new_conversations: true,
      },
      pesquisa: {
        label: 'Pesquisa',
        color: '#3B82F6',
        position: 1,
        description: 'Levantamento de informações',
      },
      redacao: {
        label: 'Redação',
        color: '#F59E0B',
        position: 2,
        description: 'Criação do conteúdo',
      },
      revisao: {
        label: 'Revisão',
        color: '#8B5CF6',
        position: 3,
        description: 'Correções e ajustes',
      },
      publicado: {
        label: 'Publicado',
        color: '#10B981',
        position: 4,
        description: 'Conteúdo no ar',
      },
    },
    settings: {
      icon: '✍️',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'pauta',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'eventos',
    name: 'Gestão de Eventos',
    funnel_type: 'events',
    description: 'Organização de eventos',
    stages: {
      planejamento: {
        label: 'Planejamento',
        color: '#3B82F6',
        position: 0,
        description: 'Definição inicial',
        allow_new_conversations: true,
      },
      preparacao: {
        label: 'Preparação',
        color: '#F59E0B',
        position: 1,
        description: 'Organização e logística',
      },
      divulgacao: {
        label: 'Divulgação',
        color: '#8B5CF6',
        position: 2,
        description: 'Marketing do evento',
      },
      execucao: {
        label: 'Execução',
        color: '#EF4444',
        position: 3,
        description: 'Realização do evento',
      },
      pos_evento: {
        label: 'Pós-evento',
        color: '#10B981',
        position: 4,
        description: 'Follow-up e análise',
      },
    },
    settings: {
      icon: '🎯',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'planejamento',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'imobiliario',
    name: 'Imobiliário',
    funnel_type: 'real_estate',
    description: 'Vendas e locações',
    stages: {
      captacao: {
        label: 'Captação',
        color: '#6B7280',
        position: 0,
        description: 'Novos imóveis',
        allow_new_conversations: true,
      },
      avaliacao: {
        label: 'Avaliação',
        color: '#3B82F6',
        position: 1,
        description: 'Análise e precificação',
      },
      divulgacao: {
        label: 'Divulgação',
        color: '#F59E0B',
        position: 2,
        description: 'Marketing do imóvel',
      },
      visitas: {
        label: 'Visitas',
        color: '#8B5CF6',
        position: 3,
        description: 'Agendamentos e visitas',
      },
      negociacao: {
        label: 'Negociação',
        color: '#EF4444',
        position: 4,
        description: 'Proposta e contraproposta',
      },
      fechamento: {
        label: 'Fechamento',
        color: '#10B981',
        position: 5,
        description: 'Contrato assinado',
      },
    },
    settings: {
      icon: '🏠',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'captacao',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'educacao',
    name: 'Educacional',
    funnel_type: 'education',
    description: 'Cursos e treinamentos',
    stages: {
      interesse: {
        label: 'Interesse',
        color: '#3B82F6',
        position: 0,
        description: 'Lead interessado',
        allow_new_conversations: true,
      },
      apresentacao: {
        label: 'Apresentação',
        color: '#F59E0B',
        position: 1,
        description: 'Detalhes do curso',
      },
      matricula: {
        label: 'Matrícula',
        color: '#8B5CF6',
        position: 2,
        description: 'Inscrição realizada',
      },
      em_curso: {
        label: 'Em Curso',
        color: '#10B981',
        position: 3,
        description: 'Aluno ativo',
      },
      concluido: {
        label: 'Concluído',
        color: '#EF4444',
        position: 4,
        description: 'Curso finalizado',
      },
    },
    settings: {
      icon: '🎓',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'interesse',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'juridico',
    name: 'Jurídico',
    funnel_type: 'legal',
    description: 'Processos legais',
    stages: {
      consulta: {
        label: 'Consulta',
        color: '#6B7280',
        position: 0,
        description: 'Primeiro contato',
        allow_new_conversations: true,
      },
      analise: {
        label: 'Análise',
        color: '#3B82F6',
        position: 1,
        description: 'Estudo do caso',
      },
      proposta: {
        label: 'Proposta',
        color: '#F59E0B',
        position: 2,
        description: 'Honorários e estratégia',
      },
      em_andamento: {
        label: 'Em Andamento',
        color: '#8B5CF6',
        position: 3,
        description: 'Processo ativo',
      },
      conclusao: {
        label: 'Conclusão',
        color: '#10B981',
        position: 4,
        description: 'Caso encerrado',
      },
    },
    settings: {
      icon: '⚖️',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'consulta',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
  {
    id: 'financeiro',
    name: 'Financeiro',
    funnel_type: 'financial',
    description: 'Cobrança e pagamentos',
    stages: {
      a_vencer: {
        label: 'A Vencer',
        color: '#3B82F6',
        position: 0,
        description: 'Próximo do vencimento',
        allow_new_conversations: true,
      },
      vencido: {
        label: 'Vencido',
        color: '#F59E0B',
        position: 1,
        description: 'Pagamento em atraso',
      },
      em_cobranca: {
        label: 'Em Cobrança',
        color: '#EF4444',
        position: 2,
        description: 'Processo de cobrança',
      },
      negociacao: {
        label: 'Negociação',
        color: '#8B5CF6',
        position: 3,
        description: 'Acordo em andamento',
      },
      quitado: {
        label: 'Quitado',
        color: '#10B981',
        position: 4,
        description: 'Pagamento realizado',
      },
    },
    settings: {
      icon: '💳',
      agent_ids: [],
      team_ids: [],
      auto_assign: false,
      default_stage: 'a_vencer',
      auto_move: false,
      notify_on_stage_change: true,
      allow_manual_move: true,
      enable_sla: false,
      enable_automation: false,
      conversation_limit: 0,
    },
  },
];

// Função auxiliar para criar um funil a partir de um template
export const createFunnelFromTemplate = (templateId, customSettings = {}) => {
  const template = FUNNEL_TEMPLATES.find(t => t.id === templateId);

  if (!template) {
    console.error('Template não encontrado:', templateId);
    return null;
  }

  // Criar uma cópia profunda do template
  const newFunnel = JSON.parse(JSON.stringify(template));

  // Gerar um novo ID único
  newFunnel.id = `funnel-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // Adicionar timestamps
  newFunnel.created_at = new Date().toISOString();
  newFunnel.updated_at = new Date().toISOString();

  // Mesclar configurações customizadas
  if (customSettings) {
    newFunnel.settings = {
      ...newFunnel.settings,
      ...customSettings,
    };
  }

  return newFunnel;
};

// Função para obter lista de templates disponíveis
export const getAvailableTemplates = () => {
  return FUNNEL_TEMPLATES.map(template => ({
    id: template.id,
    name: template.name,
    icon: template.settings.icon,
    description: template.description,
    stagesCount: Object.keys(template.stages).length,
  }));
};
